import { useEffect, useState } from 'react';

const useChatInputFocus = () => {
  const [isChatInputFocused, setIsChatInputFocused] = useState(false);

  useEffect(() => {
    const chatInput = document.getElementById('chatInput');

    if (!chatInput) return;

    const checkFocus = () => {
      setIsChatInputFocused(document.activeElement === chatInput);
    };

    chatInput.addEventListener('focus', checkFocus);
    chatInput.addEventListener('blur', checkFocus);

    checkFocus();

    return () => {
      chatInput.removeEventListener('focus', checkFocus);
      chatInput.removeEventListener('blur', checkFocus);
    };
  }, []);

  return { isChatInputFocused };
};

export default useChatInputFocus;
